import {
  LOAD_PRODUCTS,
  SET_LISTVIEW,
  SET_GRIDVIEW,
  UPDATE_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
  REMOVE_FILTER, // New action type
} from "./actions";

const filter_reducer = (state, action) => {
  if (action.type === LOAD_PRODUCTS) {
    let maxPrice = action.payload.map((p) => p.price);
    maxPrice = Math.max(...maxPrice);
    return {
      ...state,
      all_products: [...action.payload],
      filtered_products: [...action.payload],
      filters: { ...state.filters, max_price: maxPrice, price: maxPrice },
    };
  }

  if (action.type === SET_GRIDVIEW) {
    return {
      ...state,
      grid_view: true,
    };
  }

  if (action.type === SET_LISTVIEW) {
    return {
      ...state,
      grid_view: false,
    };
  }

  if (action.type === UPDATE_SORT) {
    return {
      ...state,
      sort: action.payload,
    };
  }

  if (action.type === SORT_PRODUCTS) {
    const { sort, filtered_products } = state;
    let tempProducts = [...filtered_products];
    if (sort === "price-lowest") {
      tempProducts = tempProducts.sort((a, b) => a.price - b.price);
    }
    if (sort === "price-highest") {
      tempProducts = tempProducts.sort((a, b) => b.price - a.price);
    }
    if (sort === "name-a") {
      tempProducts = tempProducts.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
    if (sort === "name-z") {
      tempProducts = tempProducts.sort((a, b) => {
        return b.name.localeCompare(a.name);
      });
    }
    return { ...state, filtered_products: tempProducts };
  }

  if (action.type === UPDATE_FILTERS) {
    const { name, value } = action.payload;
    let selectedFilters = [...state.selectedFilters];

    if (!selectedFilters.includes(name)) {
      selectedFilters.push(name);
    }

    if (name === "categories") {
      // For a multi‑select component, value may be an array already.
      if (Array.isArray(value)) {
        return {
          ...state,
          filters: { ...state.filters, categories: value },
        };
      } else {
        const currentSpecialities = state.filters.categories;
        const updatedSpecialities = currentSpecialities.includes(value)
          ? currentSpecialities.filter((item) => item !== value)
          : [...currentSpecialities, value];
        return {
          ...state,
          filters: { ...state.filters, categories: updatedSpecialities },
        };
      }
    }

    // Multi‑select handling for specialities
    if (name === "specialities") {
      // For a multi‑select component, value may be an array already.
      if (Array.isArray(value)) {
        return {
          ...state,
          filters: { ...state.filters, specialities: value },
        };
      } else {
        const currentSpecialities = state.filters.specialities;
        const updatedSpecialities = currentSpecialities.includes(value)
          ? currentSpecialities.filter((item) => item !== value)
          : [...currentSpecialities, value];
        return {
          ...state,
          filters: { ...state.filters, specialities: updatedSpecialities },
        };
      }
    }

    return {
      ...state,
      filters: { ...state.filters, [name]: value },
      selectedFilters,
    };
  }

  if (action.type === FILTER_PRODUCTS) {
    const { all_products } = state;
    const { text, categories, specialities, price, premium, ownerName } =
      state.filters;
    let tempProducts = [...all_products];

    // Text filter
    if (text) {
      tempProducts = tempProducts.filter((product) => {
        return product.name.toLowerCase().includes(text.toLowerCase());
      });
    }

    // Categories filter (multi‑select)
    if (categories.length > 0) {
      tempProducts = tempProducts.filter((product) =>
        product.categories && Array.isArray(product.categories)
          ? categories.some((selCat) => product.categories.includes(selCat))
          : false
      );
    }

    // Specialities filter (multi‑select)
    if (specialities.length > 0) {
      tempProducts = tempProducts.filter((product) =>
        product.specialities && Array.isArray(product.specialities)
          ? specialities.some((selSpec) =>
              product.specialities.includes(selSpec)
            )
          : false
      );
    }

    // Price filter

    if (Array.isArray(price)) {
      const [minPrice, maxPrice] = price;
      tempProducts = tempProducts.filter(
        (product) => product.price >= minPrice && product.price <= maxPrice
      );
    } else {
      // Fallback if price is not an array (for legacy cases)
      tempProducts = tempProducts.filter((product) => product.price <= price);
    }

    // Premium filter
    if (premium) {
      tempProducts = tempProducts.filter((product) => product.premium === true);
    }

    // Owner filter
    if (ownerName) {
      tempProducts = tempProducts.filter((product) =>
        product.ownerName.toLowerCase().includes(ownerName.toLowerCase())
      );
    }

    return { ...state, filtered_products: tempProducts };
  }

  if (action.type === REMOVE_FILTER) {
    const filterName = action.payload;
    let newFilters = {
      ...state.filters,
      [filterName]: filterName === "price" ? state.filters.max_price : "",
    };
    let selectedFilters = state.selectedFilters.filter(
      (filter) => filter !== filterName
    );

    if (filterName === "categories" || filterName === "specialities") {
      newFilters = { ...newFilters, [filterName]: "All" };
    }
    if (filterName === "premium") {
      newFilters = { ...newFilters, [filterName]: false };
    }

    return {
      ...state,
      filters: newFilters,
      selectedFilters,
    };
  }

  if (action.type === CLEAR_FILTERS) {
    return {
      ...state,
      filters: {
        ...state.filters,
        text: "",
        specialities: [],
        categories: [],
        price: state.filters.max_price,
        premium: false,
        ownerName: "",
      },
      selectedFilters: [],
    };
  }

  throw new Error(`No Matching "${action.type}" - action type`);
};

export default filter_reducer;
